export default __webpack_public_path__ + "static/media/help_pink.d07133e9.svg";